interface PDFViewerProps {
  pdf_path: string;
}

export default function PDFViewer({ pdf_path }: PDFViewerProps) {
  const pdfStyles = {
    height: "100vh",
  };
  return (
    <iframe title="resume" src={pdf_path} width="100%" style={pdfStyles} />
  );
}
